export const ALL_FULFILLMENT_PLANS_ALLOCATED_STATUS = 'AllFulfillmentPlansAllocated';
export const SOME_FULFILLMENT_PLANS_ALLOCATED_STATUS = 'SomeFulfillmentPlansAllocated';
export const NO_FULFILLMENT_PLANS_ALLOCATED_STATUS = 'NoFulfillmentPlansAllocated';
export const INSUFFICIENT_PERMISSIONS_STATUS = 'InsufficientPermissions';
export const ALLOCATION_CHECK_FAILED = 'AllocationCheckFailed';
